import http from '@/api/api.js'
import Vue from 'vue'
import store from '../store/index.js'
export default function del (){
	this.arr=[];
	this.curItem = {};
	this.init=function(array){
		this.arr = JSON.parse(JSON.stringify(array));
		this.resetIndex();
	};
	console.log(this.arr,'arr---');
	// 获取所有条码
	this.resetIndex = function(){
		for(let i=0;i<this.arr.length;i++){
			for(let a=0;a<this.arr[i].goodsList.length;a++){
				this.arr[i].goodsList[a].twoIndex = a;
				this.arr[i].goodsList[a].oneIndex = i;
			}
			this.arr[i].index = i;
		}
	};
	// 定位条码位置 [n,n]
	this.getPositionForCode = function(){
		for(let i=0;i<this.arr.length;i++){
			for(let a=0;a<this.arr[i].goodsList.length;a++){
				if(this.arr[i].goodsList[a].barcode===this.curItem.barcode&&this.arr[i].goodsList[a].isOut===false){
					return [i,a]
				}
			}
		}
		return [-1,-1]
	};
	// 获取匹配的一级的index        通过key:value 获取 一级商品的index
	this.getOneIndex = function (goods) {
		for (let i = 0; i < this.arr.length; i++) {
			if(this.arr[i].goodsId===goods.goodsId&&this.arr[i].skus===goods.skus){
				return i
			}
		}
		return -1;
	};
	// 仅删除二级 不改变一级的num
	this.delTwo = function(posi){
		this.arr[posi[0]].goodsList.splice(posi[1], 1);
		this.resetIndex();
	};
	// 删除 改变一级的num     （ isCheck===true:删二级 ）
	this.del = function(posi,isCheck){
		if(!isCheck){
			isCheck=false;
		}
		if(isCheck==false){
			this.arr.splice(posi[0], 1);
		}else{
			this.arr[posi[0]].num--;
			this.arr[posi[0]].goodsList.splice(posi[1], 1);
			if(this.arr[posi[0]].goodsList.length===0){
				this.del(posi)
			}
		}
		this.resetIndex();
	};
	// {checkObj:checkObj,inputObj:inputObj} 判断checkobj inputobj是否相同
	this.checkGoods = function(){
		let obj=[]
		for(let i=0;i<this.arr.length;i++){
			let checkObj = {}     //商品名称:数量
			let inputObj = {}     //商品名称:数量
			if(this.arr[i].checkGoods!=undefined){
				let k = '';
				k = this.arr[i].checkGoods.skus;
				checkObj[k]=this.arr[i].num;
				for(let b=0;b<this.arr[i].goodsList.length;b++){
					k = this.arr[i].goodsList[b].skus;
					if(inputObj[k]){
						inputObj[k]++;
					}else{
						inputObj[k]=1;
					}
				}
			}
			obj[i]={checkObj:checkObj,inputObj:inputObj}
			continue ;
		}
		return obj;
	};
	this.searchGoods = function(code,type,obj){

		code = (code).toString().trim();
		if(obj===undefined){
			obj = {}
			obj.can9 = false  // 是否限制已销售状态的条码
			obj.allShop = false  // 是否限制门店
		}else{
			obj.can9 = obj.can9===undefined?false:obj.can9
			obj.allShop = obj.allShop===undefined?false:obj.allShop
		}
		return new Promise((resolve,reject)=>{
			http.get(process.env.VUE_APP_Url_baseData + '/api/product/goods/from/code', {
				barcode: code
			}).then(res=>{
				if(res.code==0){
					let goods = res.data;
					let item = {
						activityId: '',
						activityType: 1,
						activityItem: {},
						activityList: [],
						barcode: goods.barcode,
						totaTimes:goods.totaTimes, // 总次数
						useTimes:goods.useTimes,   // 已使用次数
						onlyTimes:goods.totaTimes-goods.useTimes,
						tableKey: 'tableKey'+Math.random(),
						petId: '', 
						petName: '',
						brand: goods.brand,
						categoryId: goods.categoryId,
						categoryName: goods.categoryName,
						huotiType:code.length===15?1:0,
						goodsId: goods.goodsId, 
						goodsName: goods.goodsName,
						goodsType: goods.goodsType, //  0:商品 1:药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.卡 7.耗材 8.组合套餐
						goodsUsage: "", // 用法
						goodsDosage: "", // 用量
						originalPrice: goods.min_price, // 原价
						price: goods.min_price, // 现价
						vipPrice: goods.mprice,
						costPrice:goods.cost_price,
						num: 1, // 数量
						skus: (goods.skus||goods.goodsId), 
						skuValue: goods.skuValue,
						unitId:goods.unitId,
						unit: goods.unit,
						totalMoney: goods.min_price, 
						staff: [],  // 销售人员
						validityStopDate:goods.validityStopDate, // 有效期
						goodsList: [],
						isOut:false,
						checkGoods:[],
					}
					this.curItem = item;
					resolve(this.curItem);
				}
			}).catch(err=>{
				reject(err);
			})
		})
	}
	// 商品添加到arr
	this.addGoods = function(){
		let a = this.getPositionForCode();
	// 条码不存在
			let index = this.getOneIndex(this.curItem);
			if (index === -1) {
				this.curItem.goodsList = delete this.curItem.goodsList && [JSON.parse(JSON.stringify(this.curItem))];
				this.curItem.tableKey='tableKey'+Math.random(),
				this.arr.push(this.curItem);
			}
			if(index>=0){
				delete this.curItem.goodsList;                       // 删除二级的goodsList
				this.arr[index].goodsList.push(this.curItem);        // 插入item
				this.arr[index].num++;                               // 一级数量加1
			}
			this.resetIndex();                                    // 更新条码数组
			return true;

	};
	// 添加二级商品  TF:'chongfu,xianliang' 可以重复 限制数量不能超出
	this.addTwoGoods = function(TF=[]){
		let a = this.getPositionForCode();
		if((a[0]===-1&&a[1]===-1)||TF.indexOf('chongfu')>-1){  // 条码不存在
			let index;
			index = this.getOneIndex(this.curItem);
			if (index === -1) {
				Vue.prototype.$message({
					message: '不可录入该条码，因为列表中未找到该条码对应的商品',
					type: 'error'
				});
				// 条码对应商品不存在
				return {
					type:'mismatch',
					position:a
				}
			}
			if(index>=0){
				if(TF.indexOf('xianliang')>-1){
					if(this.arr[index].num===this.arr[index].goodsList.length){
						Vue.prototype.$message({
							message: '该商品只能录入 '+this.arr[index].num+' 个条码',
							type: 'error'
						});
						// 条码数量超出
						return {
							type:'quantityExceeds',
							position:index
						}
					}
				}
				delete this.curItem.goodsList;                       // 删除二级的goodsList
				this.arr[index].goodsList.push(this.curItem);        // 插入item
			}
			this.resetIndex();                                    // 更新条码数组
			return true;
		}else{
			Vue.prototype.$message({
				message: this.curItem.barcode+' 该条码已存在',
				type: 'error'
			});
			// 条码已经存在
			return {
				type:'exist',
				position:a
			}
		}
	};
	// 判断条码状态  废弃
	// this.getAllCodeState=function(){
	// 	return new Promise((resolve)=>{
	// 		let params=[]
	// 		for(let i=0;i<this.arr.length;i++){
	// 			for(let a=0;a<this.arr[i].goodsList.length;a++){
	// 				if(this.arr[i].goodsList[a].barcode){
	// 					params.push(this.arr[i].goodsList[a].barcode)
	// 				}
	// 			}
	// 		}
	// 		http.post('/api/Goods/GetCodeStatusInfo', params).then(res=>{
	// 			resolve(res)
	// 		})
	// 	})
	// }
}

